module.exports = __webpack_public_path__ + "static/media/lp5.61e9992f.jpg";